module.exports = __webpack_public_path__ + "img/teddy_cigar.8afadade.png";